import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';
import LoadingIndicator from './LoadingIndicator';
import CodeTotalsIndicator from './CodeTotalsIndicator';

const CodesTableFooter = () => {
    const isLoadingCodes = useSelector(
        (state) => state.daylight.isLoadingCodes
    );

    return (
        <Row className="total-row justify-content-start pt-4">
            <Col>
                <CodeTotalsIndicator />
            </Col>
            {isLoadingCodes && (
                <Col xs="auto" className="text-nowrap ml-auto">
                    <LoadingIndicator />
                </Col>
            )}
        </Row>
    );
};

export default CodesTableFooter;
